export const getActiveBenefits = (benefits) => {
    return benefits.filter(item => item.status === true).map(item => ({...item, isActive: true}));
};